import { render, staticRenderFns } from "./RestaurantBlock.vue?vue&type=template&id=0cbd95e6"
import script from "./RestaurantBlock.vue?vue&type=script&lang=js"
export * from "./RestaurantBlock.vue?vue&type=script&lang=js"
import style0 from "./RestaurantBlock.vue?vue&type=style&index=0&id=0cbd95e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports